import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BannerTextoGrandeContainerService } from './banner-texto-grande-container.service';

@Component({
  selector: 'fcp-banner-texto-grande-container',
  template: `
    <fcp-banner-texto-grande
      [banner]="banner | async"
    ></fcp-banner-texto-grande>
  `
})
export class BannerTextoGrandeContainerComponent implements OnInit {
  @Input() private id: string;
  public banner: Observable<any>;

  constructor(
    private BannerTextoGrandeContainerService: BannerTextoGrandeContainerService
  ) {}

  ngOnInit() {
    this.banner = this.BannerTextoGrandeContainerService.getBannerTextoGrande(
      this.id
    );
  }
}
